(function () {
  var header = document.querySelector('[data-header]');
  if (header) {
    var threshold = Math.max(window.innerHeight * 0.6, 240);
    var ticking = false;

    function updateHeaderState() {
      var scrolled = window.scrollY > threshold;
      header.classList.toggle('is-scrolled', scrolled);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    }

    if (header.hasAttribute('data-transparent-hero')) {
      window.addEventListener('scroll', onScroll, { passive: true });
      updateHeaderState();
    } else {
      header.classList.add('is-scrolled');
    }
  }

  var drawer = document.querySelector('[data-drawer]');
  var backdrop = document.querySelector('[data-drawer-backdrop]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');

  if (drawer && backdrop && openBtn) {
    function openDrawer() {
      drawer.classList.add('is-open');
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
      });
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var firstLink = drawer.querySelector('a');
      if (firstLink) firstLink.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) backdrop.hidden = true;
      }, 320);
      openBtn.focus();
    }

    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }
})();
